import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations, LANGS } from "../i18n/translations";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("nour_lang") || "fr");

  useEffect(() => {
    localStorage.setItem("nour_lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  const value = useMemo(() => {
    const t = translations[lang] || translations.fr;
    return { lang, setLang, t, langs: LANGS };
  }, [lang]);

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
}

export const useApp = () => {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be inside AppProvider");
  return ctx;
};
